
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.389 17.889c.362 0 .665-.123.91-.367.245-.245.368-.549.368-.91 0-.363-.123-.666-.368-.911a1.236 1.236 0 00-.91-.368c-.362 0-.666.123-.91.368a1.236 1.236 0 00-.368.91c0 .362.123.666.367.91.245.245.549.368.91.368zm0-5.111c.362 0 .665-.123.91-.368s.368-.548.368-.91-.123-.665-.368-.91a1.236 1.236 0 00-.91-.368c-.362 0-.666.123-.91.368a1.236 1.236 0 00-.368.91c0 .362.123.665.367.91.245.245.549.368.91.368zm0-5.111c.362 0 .665-.123.91-.368s.368-.548.368-.91-.123-.666-.368-.91a1.236 1.236 0 00-.91-.368c-.362 0-.666.123-.91.367a1.236 1.236 0 00-.368.91c0 .363.123.666.367.911.245.245.549.368.91.368zM11.5 17.889h5.111c.362 0 .666-.123.91-.367.245-.245.368-.549.368-.91 0-.363-.123-.666-.367-.911a1.236 1.236 0 00-.91-.368H11.5c-.362 0-.665.123-.91.368a1.236 1.236 0 00-.368.91c0 .362.123.666.368.91.245.245.548.368.91.368zm0-5.111h5.111c.362 0 .666-.123.91-.368.245-.245.368-.548.368-.91s-.123-.665-.367-.91a1.236 1.236 0 00-.91-.368H11.5c-.362 0-.665.123-.91.368a1.236 1.236 0 00-.368.91c0 .362.123.665.368.91s.548.368.91.368zm0-5.111h5.111c.362 0 .666-.123.91-.368.245-.245.368-.548.368-.91s-.123-.666-.367-.91a1.236 1.236 0 00-.91-.368H11.5c-.362 0-.665.123-.91.367a1.236 1.236 0 00-.368.91c0 .363.123.666.368.911s.548.368.91.368zM2.556 23a2.46 2.46 0 01-1.805-.75A2.46 2.46 0 010 20.443V2.556C0 1.853.25 1.25.75.75 1.252.25 1.854 0 2.557 0h17.888c.703 0 1.305.25 1.805.75.5.501.751 1.103.751 1.806v17.888a2.46 2.46 0 01-.75 1.805c-.501.5-1.103.751-1.806.751H2.556zm0-2.556h17.888V2.556H2.556v17.888z","fill":"#fff"}})])
          )
        }
      }
    